const fonts = {
  family: {
    lato: "'Lato', Helvetica Neue, Helvetica, Arial, sans-serif",
    workSans: "'Work Sans', Helvetica Neue, Helvetica, Arial, sans-serif"
  },
}

export default fonts
